// extracted by css-extract-rspack-plugin
export default {"control":"MBP6SIQbsfMLtNJl"};